import { Grid, Stack } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox, SiNoChip } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionNOTESFields } from '../types/fields';
import { OperacionNOTES } from "../types/types";
import { NOTESNotaTipo } from "../types/enum";

type SeccionNOTESDatosSeccionesProps = {
  operacion?: OperacionNOTES;
}

const SeccionNOTESDatosSecciones = ({ operacion }: SeccionNOTESDatosSeccionesProps) => {
  if (!operacion) return null;

  return (
    <Stack gap={3}>
      <CardActions title='Sección - Información General' icon='mdi:information-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} >
            <FieldView label='Tipo de Nota' value={operacion[OperacionNOTESFields.DescTipoNota]} />
          </Grid>
          {operacion[OperacionNOTESFields.TipoVirtualNota] !== NOTESNotaTipo.PUENTE && (
            <Grid item xs={12}>
              <FieldView
                label='País'
                value={operacion[OperacionNOTESFields.NombrePais]}
              />
            </Grid>
          )}
          <Grid item xs={12} >
            <FieldView label='Moneda' value={operacion[OperacionNOTESFields.Moneda]} />
          </Grid>
          <Grid item xs={12} >
            <FieldView label='Vencimiento' value={operacion[OperacionNOTESFields.Vencimiento]} />
          </Grid>
          {
            operacion[OperacionNOTESFields.TipoVirtualNota] !== NOTESNotaTipo.A_MEDIDA &&
            <Grid item xs={12} >
              <FieldView label='Fecha de Emisión' value={dateFormatter.toShortDate(operacion[OperacionNOTESFields.FechaEmision])} />
            </Grid>
          }

          <Grid item xs={12}>
            <FieldView label='Emisor' value={operacion[OperacionNOTESFields.Emisor]} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Sub-yacentes' icon='mdi:chart-scatter-plot' colapsable>
        <SectionBox>
          <Grid item xs={12}>
            <FieldView label='Subyacentes' value={operacion[OperacionNOTESFields.Subyacentes]} />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsSubyacentes]} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Cupón' icon='mdi:percent' colapsable>
        <SectionBox>
          <Grid item xs={3}>
            <FieldView label='Tiene Cupón'>
              <SiNoChip value={operacion[OperacionNOTESFields.TieneCupon]} />
            </FieldView>

          </Grid>
          {
            operacion[OperacionNOTESFields.TieneCupon]
            &&
            <>
              <Grid item xs={12} >
                <FieldView label='Cupón' value={operacion[OperacionNOTESFields.Cupon]} />
              </Grid>
              <Grid item xs={12} >
                <FieldView label='Frecuencia de pago' value={operacion[OperacionNOTESFields.FrecuenciaPago]} />
              </Grid>
              <Grid item xs={12} >
                <FieldView label='Condición de pago' value={operacion[OperacionNOTESFields.CondicionPago]} />
              </Grid>
              <Grid item xs={12}>
                <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsCupon]} />
              </Grid>
            </>
          }

        </SectionBox>
      </CardActions>

      <CardActions title='Sección Rescate Anticipado' icon='mdi:calendar-remove-outline' colapsable>
        <SectionBox>
          <Grid item xs={3}>
            <FieldView label='Tiene Rescate Anticipado'>
              <SiNoChip value={operacion[OperacionNOTESFields.TieneRescateAnticipado]} />
            </FieldView>

          </Grid>
          {
            operacion[OperacionNOTESFields.TieneRescateAnticipado]
            &&
            <>
              <Grid item xs={12} >

                <FieldView label='Barrera de rescate anticipado' value={operacion[OperacionNOTESFields.BarreraRescateAnticipado]} />
              </Grid>
              <Grid item xs={12} >
                <FieldView label='Condición de rescate anticipado' value={operacion[OperacionNOTESFields.CondicionRescateAnticipado]} />
              </Grid>
              <Grid item xs={12} >
                <FieldView label='Frecuencia de observación' value={operacion[OperacionNOTESFields.FrecuenciaObservacion]} />
              </Grid>
              <Grid item xs={12}>
                <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsRescateAnticipado]} />
              </Grid>
            </>
          }

        </SectionBox>
      </CardActions>

      <CardActions title='Sección Participación' icon='mdi:account-group-outline' colapsable>
        <SectionBox>
          <Grid item xs={3}>
            <FieldView label='Tiene Participación'>
              <SiNoChip value={operacion[OperacionNOTESFields.TieneParticipacion]} />
            </FieldView>

          </Grid>
          {
            operacion[OperacionNOTESFields.TieneParticipacion]
            &&
            <>
              <Grid item xs={12} >
                <FieldView label='Participación' value={operacion[OperacionNOTESFields.Participacion]} />
              </Grid>
              <Grid item xs={12} >
                <FieldView label='Forma de participación' value={operacion[OperacionNOTESFields.FormaParticipacion]} />
              </Grid>
              <Grid item xs={12} >
                <FieldView label='Descripción de la participación' value={operacion[OperacionNOTESFields.DescripcionParticipacion]} />
              </Grid>
              <Grid item xs={12}>
                <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsParticipacion]} />
              </Grid>
            </>

          }

        </SectionBox>
      </CardActions>

      <CardActions title='Sección Protección o Garantía de Capital' icon='mdi:shield-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} >
            <FieldView label='Tipo de protección' value={operacion[OperacionNOTESFields.TipoProteccion]} />
          </Grid>
          <Grid item xs={12} >
            <FieldView label='Nivel de protección' value={operacion[OperacionNOTESFields.NivelProteccion]} />
          </Grid>
          <Grid item xs={12} >
            <FieldView label='Descripción de la protección' value={operacion[OperacionNOTESFields.DescripcionProteccion]} />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsProteccion]} />
          </Grid>
        </SectionBox>
      </CardActions>


    </Stack>
  );
}

export default SeccionNOTESDatosSecciones;
